module.exports = __webpack_public_path__ + "img/img51.cfcd95bb.svg";